import { createContext } from "react"

//Context for API User updation
export const APIUserContext = createContext()

export default APIUserContext